module.exports = __webpack_public_path__ + "img/logo-farm-v1-60x60.4ffa3d97.png";